import { VFC } from 'react';
import { Badge } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';
import { FullWidthHeightSpace } from '../../../../../components/Space/FullWidthHeightSpace';
import { theme } from '../../../../../consts/themeBase';
import { ContentSensorNotFound as messages } from '../messages';

export const ContentSensorNotFound: VFC = () => (
  <FullWidthHeightSpace direction="vertical">
    <div className="text-center">
      <CloseCircleOutlined style={{ color: theme.colors.dustRed, fontSize: 100 }} />
    </div>
    <Badge status="error" text={<FormattedMessage {...messages.text} />} />
  </FullWidthHeightSpace>
);
